import "./App.css";
import Main from "./Components/Main";
import React from 'react';
import {
  BrowserRouter as Router,
  BrowserRouter,
} from "react-router-dom";
import { DepartmentCntx } from "./Js/Context/DepartmentCntx";
import { CategoryCntx } from "./Js/Context/CategoryCntx ";
import { UserCntx } from "./Js/Context/userCntx";
import { TicketCntx } from "./Js/Context/TicketCntx";
import { OrganizatonCntx } from "./Js/Context/OrganizationCntx";
import { StatesCntx } from "./Js/Context/StateCntx";
import { SearchCntx } from "./Js/Context/SearchCntx";
function App() {
    return (
        <BrowserRouter>
            <StatesCntx>
                <SearchCntx>
                    <TicketCntx>
                    <OrganizatonCntx>
                        <UserCntx>
                            <CategoryCntx>
                                <DepartmentCntx>
                                    <Main />
                                </DepartmentCntx>
                            </CategoryCntx>
                        </UserCntx>
                        </OrganizatonCntx>
                    </TicketCntx>
                </SearchCntx>
            </StatesCntx>
        </BrowserRouter>
    );
}
export default App;
